module.exports = __webpack_public_path__ + "img/frame4.119fae81.jpg";